import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {CookieService} from 'angular2-cookie/core';
import {CoefService} from './service/coef.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private _cookieService: CookieService, private router: Router, private coef: CoefService) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._cookieService.get('jwt')) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
